import React from 'react';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import { alpha, useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import Grid from '@mui/material/Grid';
import Typed from 'react-typed';

const Hero = () => {

    const theme = useTheme();

    const isMd = useMediaQuery(theme.breakpoints.up('md'), {
        defaultMatches: true,
    });

    return (
        <Grid container spacing={4} alignItems="center">

            <Grid item container xs={12} md={6} alignItems={'center'}>

                <Box
                    data-aos={isMd ? 'fade-right' : 'fade-up'}
                    paddingLeft={isMd ? 2 : 0}
                    p={2}
                >

                    <Box marginBottom={2}>

                        <Typography
                            variant="h3"
                            color="text.primary"
                            sx={{
                                fontWeight: 800,
                                lineHeight: 1.3
                            }}
                        >
                            NextGen Nexus <br />

                            <Typography
                                color={'primary'}
                                component={'span'}
                                variant={'inherit'}
                                sx={{
                                    background: `linear-gradient(180deg, transparent 82%, ${alpha(theme.palette.secondary.main, 0.3)} 0%)`,
                                }}
                            >
                                <Typed
                                    strings={[
                                        'CRM Solutions',
                                        'Website Development',
                                        'Business Automation',
                                        'Custom Software'
                                    ]}
                                    typeSpeed={80}
                                    backSpeed={40}
                                    loop={true}
                                />
                            </Typography>

                        </Typography>

                    </Box>

                    <Box marginBottom={3}>

                        <Typography
                            variant="h6"
                            component="p"
                            color="text.secondary"
                            sx={{
                                lineHeight: 1.8
                            }}
                        >
                            We build modern websites, CRM systems,
                            and business software solutions to help
                            companies automate operations and grow faster.
                        </Typography>

                    </Box>

                    <Box
                        display="flex"
                        flexDirection={{ xs: 'column', sm: 'row' }}
                        alignItems={{ xs: 'stretch', sm: 'flex-start' }}
                    >

                        <Button
                            variant="contained"
                            color="primary"
                            size="large"
                            href="#contact"
                            fullWidth={isMd ? false : true}
                        >
                            Get Started
                        </Button>

                        <Box
                            component={Button}
                            variant="outlined"
                            color="primary"
                            size="large"
                            href="#services"
                            marginTop={{ xs: 2, sm: 0 }}
                            marginLeft={{ sm: 2 }}
                            fullWidth={isMd ? false : true}
                        >
                            Explore Services
                        </Box>

                    </Box>

                </Box>

            </Grid>

            <Grid
                item
                container
                alignItems={'center'}
                justifyContent={'center'}
                xs={12}
                md={6}
                data-aos="zoom-in"
            >

                <Box
                    component={LazyLoadImage}
                    height={1}
                    width={1}
                    src={'https://images.unsplash.com/photo-1551434678-e076c223a692?q=80&w=1200&auto=format&fit=crop'}
                    alt="NextGen Nexus"
                    effect="blur"
                    boxShadow={5}
                    borderRadius={3}
                    maxWidth={650}
                    sx={{
                        objectFit: 'cover',
                        filter: theme.palette.mode === 'dark'
                            ? 'brightness(0.7)'
                            : 'none',
                    }}
                />

            </Grid>

        </Grid>
    );
};

export default Hero;